import geodesic from "./geodesic.js";
import util from "./util.js";
import webStorage from "./webStorage.js";
import logger from "./logger";

export default {
  methods: {
    /** PCモード初期表示 */
    routerPcHome() {
      this.$router.push("/pc/ov");
    },
    /** モバイルモード初期表示 */
    routerMbHome() {
      this.$router.push("/mb");
    },
    /**
     * 地図情報付与遷移
     * @param {*} path 遷移先パス
     */
    routerPush(path) {
      let setQuery = this.getMapQuery(path);
      this.$router.push({
        path: path,
        query: setQuery,
      });
    },
    /**
     * 地図情報付与遷移（テレメータ）
     * @param {*} path 遷移先パス
     */
    routerPushTm(path) {
      let setQuery = this.getMapQuery(path);
      setQuery.ofcCd = this.$store.state.Telemeter.selectedTmParam.ofcCd;
      setQuery.itmkndCd = this.$store.state.Telemeter.selectedTmParam.itmkndCd;
      setQuery.obsCd = this.$store.state.Telemeter.selectedTmParam.obsCd;
      if (this.$store.state.app.pcPanelMode) {
        setQuery.ext = 1;
      } else {
        setQuery.ext = 0;
      }
      this.$router.push({
        path: path,
        query: setQuery,
      });
    },
    /**
     * 地図情報付与遷移（簡易カメラ）
     * @param {*} path 遷移先パス
     */
    routerPushTmScam(path) {
      let setQuery = this.getMapQuery(path);
      setQuery.itmkndCd = this.$store.state.Telemeter.selectedTmParam.itmkndCd;
      setQuery.scamId = this.$store.state.Telemeter.selectedTmParam.scamId;
      setQuery.ownCd = this.$store.state.Telemeter.selectedTmParam.ownCd;
      setQuery.sysCamId = this.$store.state.Telemeter.selectedTmParam.sysCamId;
      if (this.$store.state.app.pcPanelMode) {
        setQuery.ext = 1;
      } else {
        setQuery.ext = 0;
      }
      this.$router.push({
        path: path,
        query: setQuery,
      });
    },
    /**
     * 地図情報付与遷移（危機管理）
     * @param {*} path 遷移先パス
     */
    routerPushTmSw(path) {
      let setQuery = this.getMapQuery(path);
      setQuery.ofcCd = this.$store.state.Swin.selectedSwParam.swofcCd;
      setQuery.itmkndCd = this.$store.state.Swin.selectedSwParam.itmkndCd;
      setQuery.obsCd = this.$store.state.Swin.selectedSwParam.swobsCd;
      if (this.$store.state.app.pcPanelMode) {
        setQuery.ext = 1;
      } else {
        setQuery.ext = 0;
      }
      this.$router.push({
        path: path,
        query: setQuery,
      });
    },
    /**
     * 地図情報付与遷移（河川予警報詳細）
     * @param {*} path 遷移先パス
     */
    routerPushRw(path) {
      let setQuery = this.getMapQuery(path);
      setQuery.rwid = this.$store.state.RiverWarn.selectedWarnReq.id;
      setQuery.rwtype = this.$store.state.RiverWarn.selectedWarnReq.type;
      setQuery.rwcd = this.$store.state.RiverWarn.selectedWarnReq.cd;
      this.$router.push({
        path: path,
        query: setQuery,
      });
    },
    /**
     * 地図情報付与遷移（登録地点情報）
     * @param {*} path 遷移先パス
     */
    routerPushPoint(path) {
      let setQuery = this.getMapQuery(path);
      setQuery.pidx = this.$store.state.map.selectPointIndex;
      this.$router.push({
        path: path,
        query: setQuery,
      });
    },
    /**
     * 地図情報付与遷移（PCお知らせ一覧画面）
     * @param {*} path 遷移先パス
     * @param {*} reqParam 検索条件
     */
    routerPushPcInfoList(path, reqParam) {
      // 地図情報は付与しない
      let setQuery = {
        fld: this.$store.state.app.fldCtlParty,
        infKnd: reqParam.infKnd,
        area: reqParam.area,
        trgt: reqParam.trgt,
        dvs: reqParam.dvs,
      };
      this.$router.push({
        path: path,
        query: setQuery,
      });
    },
    /**
     * 地図情報付与遷移（モバイルお知らせ一覧画面）
     * @param {*} path 遷移先パス
     * @param {*} reqParam 検索条件
     */
    routerPushMbInfoList(path, reqParam) {
      let setQuery = this.getMapQuery(path);
      setQuery.infKnd = reqParam.infKnd;
      setQuery.area = reqParam.area;
      setQuery.trgt = reqParam.trgt;
      setQuery.dvs = reqParam.dvs;
      this.$router.push({
        path: path,
        query: setQuery,
      });
    },
    /**
     * 地図情報付与遷移（PCお知らせ詳細画面）
     * @param {*} path 遷移先パス
     * @param {*} infmgcd お知らせ管理番号
     */
    routerPushPcInfoDetail(path, infmgcd) {
      // 地図情報は付与しない
      let setQuery = {
        fld: this.$store.state.app.fldCtlParty,
        infmgcd: infmgcd,
      };
      this.$router.push({
        path: path,
        query: setQuery,
      });
    },
    /**
     * 地図情報付与遷移（モバイルお知らせ詳細画面）
     * @param {*} path 遷移先パス
     * @param {*} infmgcd お知らせ管理番号
     */
    routerPushMbInfoDetail(path, infmgcd) {
      let setQuery = this.getMapQuery(path);
      setQuery.infmgcd = infmgcd;
      this.$router.push({
        path: path,
        query: setQuery,
      });
    },
    /**
     * 拡大画面の遷移
     * @param {*} path 遷移先パス
     * @param {*} ovmd 概況の表示モード
     */
    routerPushExp(path, ovmd) {
      let setQuery = this.getMapQueryExp(path, ovmd);
      this.$router.push({
        path: path,
        query: setQuery,
      });
    },
    /**
     * 地図情報付与遷移の値返却
     * @param {*} path 遷移先パス
     */
    getRouterValue(path) {
      let setQuery = this.getMapQuery(path);
      return {
        path: path,
        query: setQuery,
      };
    },
    /**
     * 地図移動時の地図情報更新
     */
    routerMapMove() {
      // 地図情報のみ更新し、他のパラメータやパスは変更しない
      let setQuery = Object.assign({}, this.$route.query);
      setQuery["zm"] = this.$store.state.map.zoom;
      setQuery["clat"] = this.$store.state.map.center[0];
      setQuery["clon"] = this.$store.state.map.center[1];

      this.$router.replace({
        path: this.$route.path,
        query: setQuery,
      });
    },
    /**
     * 地図表示切替時の地図情報更新
     */
    routerMapSetting() {
      // 地図情報のみ更新し、他のパラメータやパスは変更しない
      let setQuery = Object.assign({}, this.$route.query);
      setQuery["mapType"] = this.$store.state.map.mapType;
      setQuery["viewGrpStg"] = this.$store.state.map.viewGroup;
      setQuery["viewRd"] = this.$store.state.map.viewRadar ? 1 : 0;
      setQuery["viewRW"] = this.$store.state.map.viewRiverWarn ? 1 : 0;
      setQuery["viewRiver"] = this.$store.state.map.viewRiver ? 1 : 0;
      setQuery["viewPoint"] = this.$store.state.map.viewPoint ? 1 : 0;

      this.$router.replace({
        path: this.$route.path,
        query: setQuery,
      });
    },
    /**
     * レーダ操作更新（PCモード）
     */
    replaceRadarQueryForPc() {
      // レーダ操作パラメータのみ更新し、他のパラメータやパスは変更しない
      let setQuery = Object.assign({}, this.$route.query);
      // カレント表示の場合は日時をパラメータに保持しない
      if (this.$store.state.app.isCurrent) {
        delete setQuery["rdtime"];
      } else {
        setQuery["rdtime"] = util.formatDate(
          this.$store.state.radar.historyPlayTime
        );
      }
      setQuery["rdtype"] = this.$store.state.radar.radarType;
      setQuery["rdnum"] = this.$store.state.radar.radarNumber;
      if (this.$store.state.radar.radarNumber == 4) {
        setQuery["rdint"] = this.$store.state.radar.radarInterval;
      }
      setQuery["rdopa"] = this.$store.state.radar.radarOpacity;
      this.$router.replace({
        path: this.$route.path,
        query: setQuery,
      });
    },
    /**
     * レーダ操作更新（MBモード）
     */
    replaceRadarQueryForMb() {
      // レーダ操作パラメータのみ更新し、他のパラメータやパスは変更しない
      let setQuery = Object.assign({}, this.$route.query);
      // カレント表示の場合は日時をパラメータに保持しない
      if (this.$store.state.app.isCurrent) {
        delete setQuery["rdtime"];
      } else {
        setQuery["rdtime"] = util.formatDate(
          this.$store.state.radar.historyPlayTime
        );
      }
      setQuery["rdtype"] = this.$store.state.radar.radarType;
      setQuery["rdnum"] = 1;
      setQuery["rdopa"] = this.$store.state.radar.radarOpacity;
      this.$router.replace({
        path: this.$route.path,
        query: setQuery,
      });
    }, 
    replaceTmQuery(currentTime) {
      // 観測所操作パラメータのみ更新し、他のパラメータやパスは変更しない
      let setQuery = Object.assign({}, this.$route.query);
      if (currentTime) {
        setQuery["tmtime"] = util.formatDate(
          this.$store.state.Telemeter.historyImageSlider.movieEndTime
        );
        this.$router.replace({
          path: this.$route.path,
          query: setQuery,
        });
        return;
      }
      // カレント表示の場合は日時をパラメータに保持しない
      if (this.$store.state.app.isCurrent) {
        delete setQuery["tmtime"];
      } else {
        setQuery["tmtime"] = util.formatDate(
          this.$store.state.Telemeter.historyImageSlider.movieEndTime
        );
      }
      this.$router.replace({
        path: this.$route.path,
        query: setQuery,
      });
    },
    /**
     * 水防団モード更新
     */
    routerFldCtlParty() {
      // 水防団モードのみ更新し、他のパラメータやパスは変更しない
      let setQuery = Object.assign({}, this.$route.query);
      setQuery["fld"] = this.$store.state.app.fldCtlParty;
      this.$router.replace({
        path: this.$route.path,
        query: setQuery,
      });
    },
    /**
     * 個別観測所画面拡大モード更新
     */
    replacePanelMode(mode) {
      // 拡大モードのみ更新し、他のパラメータやパスは変更しない
      let setQuery = Object.assign({}, this.$route.query);
      setQuery["ext"] = mode;
      this.$router.push({
        path: this.$route.path,
        query: setQuery,
      });
    },
    /**
     * PCモードへ切替
     */
    routerPushChangePc(beforePath) {
      // 該当するPCモードの画面へ切り替える
      // パラメータは該当する画面が無い場合を除き基本変更しない
      let setPath = "/pc/ov";
      let setQuery = Object.assign({}, this.$route.query);
      if (beforePath == "/mb/tm") {
        setPath = "/pc/tm";
      } else if (beforePath == "/mb/tmlist") {
        setPath = "/pc/tmlist";
        // 選択タブは該当するものが存在しない場合を考慮し市町村別へ
        this.$store.commit("Telemeter/setSelectTmListTabIndex", 0);
      } else if (beforePath == "/mb/rp") {
        setPath = "/pc/rp";
      } else if (beforePath == "/mb/rwlist") {
        setPath = "/pc/rwlist";
      } else if (beforePath == "/mb/rwdetail") {
        setPath = "/pc/rw";
      } else if (beforePath == "/mb/rd") {
        setPath = "/pc/rd";
      } else if (beforePath == "/mb/iu") {
        setPath = "/pc/iu";
      } else if (beforePath == "/mb/vc") {
        setPath = "/pc/vc";
      } else {
        // 対象画面なし
        // 遷移元がお知らせ画面の場合は概況へ
        setQuery = this.getMapQuery(setPath);
      }
      this.$router.replace({
        path: setPath,
        query: setQuery,
      });
    },
    /**
     * モバイルモードへ切替
     */
    routerPushChangeMb(beforePath) {
      // 該当するモバイルモードの画面へ切り替える
      // パラメータは該当する画面が無い場合を除き基本変更しない
      let setPath = "/mb";
      let setQuery = Object.assign({}, this.$route.query);
      if (beforePath == "/pc/ov") {
        if (setQuery.ext == 1 && setQuery.ovmd == "rw") {
          // 発表情報概況(拡大)は発表情報一覧画面へ
          setPath = "/mb/rwlist";
        } else if (setQuery.ext == 1 && setQuery.ovmd == "tm") {
          // 基準値超過観測所一覧(拡大)は観測所一覧画面へ
          setPath = "/mb/tmlist";
        } else {
          // 概況は地図画面へ
          setPath = "/mb";
        }
      } else if (beforePath == "/pc/tmlist") {
        setPath = "/mb/tmlist";
      } else if (beforePath == "/pc/tm") {
        setPath = "/mb/tm";
      } else if (beforePath == "/pc/rwlist") {
        setPath = "/mb/rwlist";
      } else if (beforePath == "/pc/rw") {
        setPath = "/mb/rwdetail";
      } else if (beforePath == "/pc/rp") {
        setPath = "/mb/rp";
      } else if (beforePath == "/pc/rd") {
        setPath = "/mb/rd";
      } else if (beforePath == "/pc/iu") {
        setPath = "/mb/iu";
      } else if (beforePath == "/pc/vc") {
        setPath = "/mb/vc";
      } else if (beforePath == "/pcfull/info") {
        setPath = "/mb/info";
      } else if (beforePath == "/pcfull/info/detail") {
        setPath = "/mb/info/detail";
      } else if (beforePath == "/pcfull/ovlist") {
        setPath = "/mb/tmlist";
      } else if (beforePath == "/pcfull/tm") {
        setPath = "/mb/tm";
      } else if (beforePath == "/") {
        // ドメイン指定の場合はパラメータを付与しない
        setPath = "/mb";
      } else {
        // 対応画面なし
        setQuery = this.getMapQuery(setPath);
      }
      this.$router.replace({
        path: setPath,
        query: setQuery,
      });
    },
    /**
     * 地図画面共通クエリ取得
     * @returns 地図画面共通クエリ
     */
    getMapQuery(path) {
      let ext = 0;
      if (
        this.$store.state.app.pcPanelMode &&
        (path === "/pc/ov" || path === "/pc/tmlist" || path === "/pc/tm")
      ) {
        ext = 1;
      }
      return {
        zm: this.$store.state.map.zoom,
        clat: this.$store.state.map.center[0],
        clon: this.$store.state.map.center[1],
        fld: this.$store.state.app.fldCtlParty,
        mapType: this.$store.state.map.mapType,
        viewGrpStg: this.$store.state.map.viewGroup,
        viewRd: this.$store.state.map.viewRadar ? 1 : 0,
        viewRW: this.$store.state.map.viewRiverWarn ? 1 : 0,
        viewRiver: this.$store.state.map.viewRiver ? 1 : 0,
        viewPoint: this.$store.state.map.viewPoint ? 1 : 0,
        ext: ext,
      };
    },
    /**
     * 地図画面共通クエリ取得
     * @param {*} path 遷移先パス
     * @param {*} ovmd 概況の表示モード
     * @returns
     */
    getMapQueryExp(path, ovmd) {
      let ext = 0;
      if (
        this.$store.state.app.pcPanelMode &&
        (path === "/pc/ov" || path === "/pc/tmlist" || path === "/pc/tm")
      ) {
        ext = 1;
      }
      if (ovmd) {
        return {
          zm: this.$store.state.map.zoom,
          clat: this.$store.state.map.center[0],
          clon: this.$store.state.map.center[1],
          fld: this.$store.state.app.fldCtlParty,
          mapType: this.$store.state.map.mapType,
          viewGrpStg: this.$store.state.map.viewGroup,
          viewRd: this.$store.state.map.viewRadar ? 1 : 0,
          viewRW: this.$store.state.map.viewRiverWarn ? 1 : 0,
          viewRiver: this.$store.state.map.viewRiver ? 1 : 0,
          viewPoint: this.$store.state.map.viewPoint ? 1 : 0,
          ext: ext,
          ovmd: ovmd,
        };
      } else {
        return {
          zm: this.$store.state.map.zoom,
          clat: this.$store.state.map.center[0],
          clon: this.$store.state.map.center[1],
          fld: this.$store.state.app.fldCtlParty,
          mapType: this.$store.state.map.mapType,
          viewGrpStg: this.$store.state.map.viewGroup,
          viewRd: this.$store.state.map.viewRadar ? 1 : 0,
          viewRW: this.$store.state.map.viewRiverWarn ? 1 : 0,
          viewRiver: this.$store.state.map.viewRiver ? 1 : 0,
          viewPoint: this.$store.state.map.viewPoint ? 1 : 0,
          ext: ext,
        };
      }
    },
    /**
     * 市町村名取得範囲取得
     * @param center 中心座標
     */
    getTownNameRange(center) {
      // 中心座標から設定値分離れた範囲の座標を返す
      return geodesic.getBounds(
        center,
        this.$store.state.app.config.appConfig.townNameRangeKilo
      );
    },
    /**
     * PWAの初期化・トークンのストア保持を行う
     */
    initPwa() {
      logger.debug("[initPwa] initPwa");

      const config = {
        apiKey: "AIzaSyBHe0GluBSOdzP5GV9dmPXupOK8FpYJ2fI",
        authDomain: "gkwb-82bf2.firebaseapp.com",
        projectId: "gkwb-82bf2",
        storageBucket: "gkwb-82bf2.appspot.com",
        messagingSenderId: "381028038385",
        appId: "1:381028038385:web:ba810ce4466b5528f11b50",
        measurementId: "G-PCJ915Q3MH",
      };

      try {
        if (!("Notification" in window)) {
          logger.debug("[initPwa] Notification : not supported");
          // 通知許可をした場合のストア・webストレージ登録
          this.setDefaultNotification();
        }

        const firebase = require("firebase/app");
        require("firebase/messaging"); // for cloud messaging
        if (!firebase.apps.length && "serviceWorker" in navigator) {
          navigator.serviceWorker
            .register("/kawabou/firebase-messaging-sw.js")
            .then((registration) => {
              firebase.initializeApp(config);
              var messaging = {};

              messaging = firebase.messaging();
              messaging.useServiceWorker(registration);
              messaging.usePublicVapidKey(
                "BD6AFWF6OGL754dkveQzQU0r098SGw8w3Aa1xoT6XK0RuBVpDJzPZDlscYXCibHBtacOn-ArnKLvOD_S0mC0tug"
              );

              // 通知の受信許可
              messaging
                .requestPermission()
                .then(() => {
                  // トークン取得
                  messaging.getToken().then((token) => {
                    // logger.debug("[initPwa] token :" + token);

                    // トークンをストアに格納
                    this.$store.commit("app/setToken", token);
                    // 通知許可をストアに格納
                    this.$store.commit("app/setPermission", true);
                    // 通知許可を行った場合はwebストレージに登録
                    webStorage.setNotification({
                      permission: true,
                      date: util.formatDate(util.toDate()),
                      token: token,
                    });
                  });

                  // トークン更新のモニタリング
                  messaging.onTokenRefresh(() => {
                    messaging
                      .getToken()
                      .then((refreshedToken) => {
                        logger.debug(
                          "[initPwa] refreshedToken :" + refreshedToken
                        );
                      })
                      .catch((err) => {
                        logger.debug(
                          "[initPwa] Unable to retrieve refreshed token :" + err
                        );
                      });
                  });
                })
                .catch((err) => {
                  logger.debug(
                    "[initPwa] Unable to get permission to notify :" + err
                  );
                  // 通知許可をした場合のストア・webストレージ登録
                  this.setDefaultNotification();
                });
            });
        } else {
          // 通知許可をした場合のストア・webストレージ登録
          this.setDefaultNotification();
        }
      } catch (ex) {
        logger.debug("[initPwa] PWAが使用出来ない環境 :");
        logger.debug(ex);
        // 通知許可をした場合のストア・webストレージ登録
        this.setDefaultNotification();
      }
    },
    // 通知許可をした場合のストア・webストレージ登録
    setDefaultNotification() {
      // 通知許可をストアに格納
      this.$store.commit("app/setPermission", true);
      // 通知許可を行った場合はwebストレージに登録
      webStorage.setNotification({
        permission: true,
        date: util.formatDate(util.toDate()),
        token: "",
      });
    },
    // ブラウザのページタイトル編集
    setPageTitle(title) {
      if (title) {
        // title = typeof title === "function" ? title.call(this) : title;
        document.title = `${process.env.VUE_APP_TITLE} : ${title}`;
      } else {
        document.title = `${process.env.VUE_APP_TITLE}`;
      }
    },
    /**
     * 観測所詳細画面に遷移
     * @param {*} path 遷移先パス
     */
    routerPushPcFullTm(path) {
      let query = {};
      if (!this.$store.state.app.isCurrent) {
        query = {
          itmkndCd: this.$store.state.Telemeter.selectedTmParam.itmkndCd,
          ofcCd: this.$store.state.Telemeter.selectedTmParam.ofcCd,
          obsCd: this.$store.state.Telemeter.selectedTmParam.obsCd,
          appTime: util.formatDate(this.$store.state.app.appTime, "YYYY-MM-DD HH:mm"),
          isCurrent: this.$store.state.app.isCurrent,
          fld: this.$store.state.app.fldCtlParty,
        }
      } else {
        query = {
          itmkndCd: this.$store.state.Telemeter.selectedTmParam.itmkndCd,
          ofcCd: this.$store.state.Telemeter.selectedTmParam.ofcCd,
          obsCd: this.$store.state.Telemeter.selectedTmParam.obsCd,
          isCurrent: this.$store.state.app.isCurrent,
          fld: this.$store.state.app.fldCtlParty,
        }
      }
      this.$router.push({
        path: path,
        query: query,
      });
    },
    /**
     * 観測所詳細画面に遷移（危機管理）
     * @param {*} path 遷移先パス
     */
    routerPushPcFullTmSw(path) {
      let query = {};
      if (!this.$store.state.app.isCurrent) {
        query = {
          itmkndCd: this.$store.state.Swin.selectedSwParam.itmkndCd,
          ofcCd: this.$store.state.Swin.selectedSwParam.swofcCd,
          obsCd: this.$store.state.Swin.selectedSwParam.swobsCd,
          appTime: util.formatDate(
            this.$store.state.app.appTime,
            "YYYY-MM-DD HH:mm"
          ),
          appTimeRound: util.formatDate(
            this.$store.state.app.appTimeRound,
            "YYYY-MM-DD HH:mm"
          ),
          isCurrent: this.$store.state.app.isCurrent,
          fld: this.$store.state.app.fldCtlParty,
        }
      } else {
        query = {
          itmkndCd: this.$store.state.Swin.selectedSwParam.itmkndCd,
          ofcCd: this.$store.state.Swin.selectedSwParam.swofcCd,
          obsCd: this.$store.state.Swin.selectedSwParam.swobsCd,
          isCurrent: this.$store.state.app.isCurrent,
          fld: this.$store.state.app.fldCtlParty,
        }
      }
      this.$router.push({
        path: path,
        query: query,
      });
    },
    /**
     * 観測所詳細画面に遷移
     * @param {*} path 遷移先パス
     */
    routerOpenTm(path) {
      let setQuery = this.getMapQuery(path);
      setQuery.ofcCd = this.$store.state.Telemeter.selectedTmParam.ofcCd;
      setQuery.itmkndCd = this.$store.state.Telemeter.selectedTmParam.itmkndCd;
      setQuery.obsCd = this.$store.state.Telemeter.selectedTmParam.obsCd;
      setQuery.ext = this.$store.state.app.pcPanelMode ? 1 : 0;
      if (this.$route.query["tmtime"]) {
        setQuery.tmtime = this.$route.query["tmtime"];
      }
      setQuery = this.routerMapSettingFromWebStorage(setQuery);
      let routeData = this.$router.resolve({
        path: path,
        query: setQuery,
      });
      window.open(routeData.href, "_self");
    },
    /**
     * 観測所詳細画面に遷移（危機管理）
     * @param {*} path 遷移先パス
     */
    routerOpenTmSw(path) {
      let setQuery = this.getMapQuery(path);
      setQuery.ofcCd = this.$store.state.Swin.selectedSwParam.swofcCd;
      setQuery.itmkndCd = this.$store.state.Swin.selectedSwParam.itmkndCd;
      setQuery.obsCd = this.$store.state.Swin.selectedSwParam.swobsCd;
      setQuery.ext = this.$store.state.app.pcPanelMode ? 1 : 0;
      if (this.$route.query["tmtime"]) {
        setQuery.tmtime = this.$route.query["tmtime"];
      }
      setQuery = this.routerMapSettingFromWebStorage(setQuery);
      let routeData = this.$router.resolve({
        path: path,
        query: setQuery,
      });
      window.open(routeData.href, "_self");
    },
    /**
     * 地図表示切替時の地図情報更新
     * @param {*} setQuery クエリ
     * @returns 地図画面共通クエリ
     */
    routerMapSettingFromWebStorage(setQuery) {
      // WebStorageから地図設定を取得
      const info = webStorage.getDefaultInfo();

      if (info) {
        if (info.flood != undefined) {
          setQuery.fld = info.flood ? 1 : 0;
        }
        if (info.mapType != undefined) {
          setQuery.mapType = info.mapType;
        }
        if (info.disp1 != undefined && info.disp1) {
          setQuery.viewGrpStg = 0;
        } else if (info.disp2 != undefined && info.disp2) {
          setQuery.viewGrpStg = 1;
        } else if (info.disp3 != undefined && info.disp3) {
          setQuery.viewGrpStg = 2;
        } else if (info.disp4 != undefined && info.disp4) {
          setQuery.viewGrpStg = 3;
        } else if (info.disp5 != undefined && info.disp5) {
          setQuery.viewGrpStg = 4;
        } else if (info.dispCustom != undefined && info.dispCustom) {
          setQuery.viewGrpStg = 5;
        }
        if (info.viewRd != undefined) {
          setQuery.viewRd = info.viewRd ? 1 : 0;
        }
        if (info.viewRw != undefined) {
          setQuery.viewRW = info.viewRw ? 1 : 0;
        }
        if (info.viewRvrln != undefined) {
          setQuery.viewRiver = info.viewRvrln ? 1 : 0;
        }
        if (info.viewRp != undefined) {
          setQuery.viewPoint = info.viewRp ? 1 : 0;
        }
      } else {
        // WebStorageに地図設定がない場合、初期値を設定
        setQuery.fld = 0;
        setQuery.mapType = 0;
        setQuery.viewGrpStg = 0;
        setQuery.viewRd = 1;
        setQuery.viewRW = 1;
        setQuery.viewRiver = 1;
        setQuery.viewPoint = 1;
      }

      return setQuery;
    },
  },
};
